<template>
    <form class="na-form" @submit="onSaveClick($event)">
        <div v-if="mta" class="left">
            <DxTabPanel>
                <DxItem :title="tx.TabBaseData">
                    <div class="dx-fieldset">
                        <!--<div class="dx-fieldset-header">Personal Data</div>-->
                        <div class="dx-field">
                            <div class="dx-field-label">{{ tx.MtyId }}:</div>
                            <div class="dx-field-value">
                                <DxTextBox :value='mta.MatId' :readOnly="true" />
                            </div>
                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">{{ tx.MatUniqueNumber }}:</div>
                            <div class="dx-field-value">
                                <DxTextBox :value='mta.MatUniqueNumber' :readOnly="true" />
                            </div>
                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">{{ tx.AttributeName }}:</div>
                            <div class="dx-field-value">
                                <DxTextBox :value='"Atr_" + mta.AtrId' :readOnly="true" />
                            </div>
                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">{{ tx.AtyName }}:</div>
                            <div class="dx-field-value">
                                <DxTextBox :value='mta.AtyName' :readOnly="true" />
                            </div>
                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">{{ tx.MatPosition }}*:</div>
                            <div class="dx-field-value">
                                <DxNumberBox v-model:value='mta.MatPosition'>
                                    <DxValidator>
                                        <DxRequiredRule :message="tx.MatPosition" />
                                    </DxValidator>
                                </DxNumberBox>
                            </div>
                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">{{ tx.MatPageNr }}*:</div>
                            <div class="dx-field-value">
                                <DxNumberBox v-model:value='mta.MatPageNr'>
                                    <DxValidator>
                                        <DxRequiredRule :message="tx.MatPageNr" />
                                    </DxValidator>
                                </DxNumberBox>
                            </div>
                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">{{ tx.MatCaption }}*:</div>
                            <div class="dx-field-value">
                                <DxTextBox v-model:value='mta.MatCaption'>
                                </DxTextBox>
                            </div>
                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">{{ tx.MatHideCaptionInReadonly }}:</div>
                            <div class="dx-field-value">
                                <DxCheckBox v-model:value='mta.MatHideCaptionInReadonly'>
                                </DxCheckBox>
                            </div>
                            <div class="udc-description">
                                <div class="udc-field-required"></div>
                                <div class="udc-field-description"></div>
                            </div>
                        </div>
                        <div class="dx-field" v-if="mta.AtyId == 1 || mta.AtyId == 2">
                            <div class="dx-field-label">{{ tx.MatIsHyperLink }}:</div>
                            <div class="dx-field-value">
                                <DxCheckBox v-model:value='mta.MatIsHyperLink'>
                                </DxCheckBox>
                            </div>
                            <div class="udc-description">
                                <div class="udc-field-required"></div>
                                <div class="udc-field-description">Only set to true if filled by trusted sources</div>
                            </div>
                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">{{ tx.MatDescriptionInt }}:</div>
                            <div class="dx-field-value">
                                <DxHtmlEditor v-model:value='mta.MatDescription'
                                              :autoResizeEnabled="true">
                                    <DxToolbar>
                                        <DxItem name="undo" />
                                        <DxItem name="redo" />
                                        <DxItem name="separator" />
                                        <DxItem :accepted-values="sizeValues"
                                                name="size" />
                                        <!--<DxItem :accepted-values="fontValues"
                                                name="font" />-->
                                        <DxItem name="separator" />
                                        <DxItem name="bold" />
                                        <DxItem name="italic" />
                                        <DxItem name="strike" />
                                        <DxItem name="underline" />
                                        <DxItem name="separator" />
                                        <DxItem name="alignLeft" />
                                        <DxItem name="alignCenter" />
                                        <DxItem name="alignRight" />
                                        <DxItem name="alignJustify" />
                                        <DxItem name="separator" />
                                        <DxItem name="color" />
                                        <DxItem name="background" />
                                        <DxItem name="variable" />
                                    </DxToolbar>
                                </DxHtmlEditor>
                            </div>
                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">{{ tx.MatDescriptionExt }}:</div>
                            <div class="dx-field-value">
                                <DxHtmlEditor v-model:value='mta.MatDescription2'
                                              :autoResizeEnabled="true">
                                    <DxToolbar>
                                        <DxItem name="undo" />
                                        <DxItem name="redo" />
                                        <DxItem name="separator" />
                                        <DxItem :accepted-values="sizeValues"
                                                name="size" />
                                        <!--<DxItem :accepted-values="fontValues"
                                                name="font" />-->
                                        <DxItem name="separator" />
                                        <DxItem name="bold" />
                                        <DxItem name="italic" />
                                        <DxItem name="strike" />
                                        <DxItem name="underline" />
                                        <DxItem name="separator" />
                                        <DxItem name="alignLeft" />
                                        <DxItem name="alignCenter" />
                                        <DxItem name="alignRight" />
                                        <DxItem name="alignJustify" />
                                        <DxItem name="separator" />
                                        <DxItem name="color" />
                                        <DxItem name="background" />
                                        <DxItem name="variable" />
                                    </DxToolbar>
                                </DxHtmlEditor>
                            </div>
                        </div>
                        <div class="dx-field" v-if="mta.AtyId == 23">
                            <div class="dx-field-label">{{ tx.MatTemplate }}:</div>
                            <div class="dx-field-value">
                                <DxTextArea v-model:value='mta.MatTemplate'
                                            :autoResizeEnabled="true">
                                </DxTextArea>
                            </div>
                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">{{ tx.MatToolTip }}:</div>
                            <div class="dx-field-value">
                                <DxTextBox v-model:value='mta.MatToolTip'>
                                </DxTextBox>
                            </div>
                        </div>
                        <div class="dx-field" v-if="mta.AtyId == 1 || mta.AtyId == 2 || mta.AtyId == 21">
                            <div class="dx-field-label">{{ tx.MatMinLength }}*:</div>
                            <div class="dx-field-value">
                                <DxNumberBox v-model:value='mta.MatMinLength' :min="0">
                                    <DxValidator>
                                        <DxRequiredRule :message="tx.MatMinLength" />
                                    </DxValidator>
                                </DxNumberBox>
                            </div>
                        </div>
                        <div class="dx-field" v-if="mta.AtyId == 19 || mta.AtyId == 21">
                            <div class="dx-field-label">{{ tx.MatMaxLength }}+:</div>
                            <div class="dx-field-value">
                                <DxNumberBox v-model:value='mta.MatMaxLength' :min="0">
                                    <DxValidator>
                                        <DxRequiredRule :message="tx.MatMaxLength" />
                                    </DxValidator>
                                </DxNumberBox>
                                <br />max {{ mta.fieldLength }}
                                <span v-if="mta.AtyId == 19">bytes</span>
                                <span v-if="mta.AtyId == 21">selection</span>
                            </div>
                        </div>
                        <div class="dx-field" v-if="mta.AtyId == 19">
                            <div class="dx-field-label">{{ tx.MatMaxFiles }}*:</div>
                            <div class="dx-field-value">
                                <DxNumberBox v-model:value='mta.MatMaxFiles' :min="0">
                                </DxNumberBox>
                            </div>
                        </div>
                        <div class="dx-field" v-if="mta.AtyId == 1 || mta.AtyId == 2">
                            <div class="dx-field-label">{{ tx.MatMaxLength }}*:</div>
                            <div class="dx-field-value">
                                <DxNumberBox v-model:value='mta.MatMaxLength' :min="0" :max="mta.fieldLength">
                                    <DxValidator>
                                        <DxRequiredRule :message="tx.MatMaxLength" />
                                        <DxCompareRule comparison-type="<="
                                                       :comparisonTarget="getFieldLength"
                                                       :message="tx.MatMaxLength" />
                                    </DxValidator>
                                </DxNumberBox>
                                <br />max {{ mta.fieldLength }} characters
                            </div>
                        </div>


                        <div class="dx-field">
                            <div class="dx-field-label">{{ tx.MatRequired }}:</div>
                            <div class="dx-field-value">
                                <DxCheckBox v-model:value='mta.MatRequired'>
                                </DxCheckBox>
                            </div>
                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">{{ tx.MatValidationRegEx }}:</div>
                            <div class="dx-field-value">
                                <DxTextArea v-model:value='mta.MatValidationRegEx' :autoResizeEnabled="true">
                                </DxTextArea>
                            </div>
                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">{{ tx.MatValidationRegExErrorMessage }}:</div>
                            <div class="dx-field-value">
                                <DxTextArea v-model:value='mta.MatValidationRegExErrorMessage' :autoResizeEnabled="true">
                                </DxTextArea>
                            </div>
                        </div>

                        <div class="dx-field">
                            <div class="dx-field-label">{{ tx.MatIsReadonly }}:</div>
                            <div class="dx-field-value">
                                <DxCheckBox v-model:value='mta.MatIsReadonly'>
                                </DxCheckBox>
                            </div>
                        </div>

                        <div class="dx-field">
                            <div class="dx-field-label">{{ tx.MatShowInForm }}:</div>
                            <div class="dx-field-value">
                                <DxCheckBox v-model:value='mta.MatShowInForm'>
                                </DxCheckBox>
                            </div>
                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">{{ tx.MatShowInOverview }}:</div>
                            <div class="dx-field-value">
                                <DxCheckBox v-model:value='mta.MatShowInOverview'>
                                </DxCheckBox>
                            </div>
                        </div>
                        <div class="dx-field" v-if="mta.MatShowInOverview == true">
                            <div class="dx-field-label">{{ tx.MatListCaption }}:</div>
                            <div class="dx-field-value">
                                <DxTextBox v-model:value='mta.MatListCaption'>
                                </DxTextBox>
                            </div>
                        </div>
                        <div class="dx-field" v-if="mta.MatShowInOverview == true">
                            <div class="dx-field-label">{{ tx.MatListVisible }}:</div>
                            <div class="dx-field-value">
                                <DxCheckBox v-model:value='mta.MatListVisible'>
                                </DxCheckBox>
                            </div>
                        </div>
                        <div class="dx-field" v-if="mta.MatShowInOverview == true">
                            <div class="dx-field-label">{{ tx.MatListPosition }}:</div>
                            <div class="dx-field-value">
                                <DxNumberBox v-model:value='mta.MatListPosition'>
                                </DxNumberBox>
                            </div>
                        </div>

                        <div class="dx-field">
                            <div class="dx-field-label">{{ tx.MatShowInProfile }}:</div>
                            <div class="dx-field-value">
                                <DxCheckBox v-model:value='mta.MatShowInProfile'>
                                </DxCheckBox>
                            </div>
                        </div>

                        <div class="dx-field">
                            <div class="dx-field-label">{{ tx.MatShowInReport }}:</div>
                            <div class="dx-field-value">
                                <DxCheckBox v-model:value='mta.MatShowInReport'>
                                </DxCheckBox>
                            </div>
                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">{{ tx.MatShowInPresentationArea }}:</div>
                            <div class="dx-field-value">
                                <DxCheckBox v-model:value='mta.MatShowInPresentationArea'>
                                </DxCheckBox>
                            </div>
                        </div>
                        <div class="dx-field" v-if="mta.AtyId == 24">
                            <div class="dx-field-label">{{ tx.TopicLinkType }}:</div>
                            <div class="dx-field-value">
                                <DxSelectBox :data-source="topicLinkTypeList"
                                             :show-clear-button="true"
                                             display-expr="TtyName"
                                             value-expr="TltId"
                                             v-model:value='mta.MatFilterTltId'
                                             @value-changed="onMatFilterTltIdChanged">
                                </DxSelectBox>
                            </div>
                        </div>

                        <div class="dx-field" v-if="mta.AtyId == 3 || mta.AtyId == 12 || mta.AtyId == 14 || mta.AtyId == 20 || mta.AtyId == 21">
                            <div class="dx-field-label">{{ tx.MatListFilterid }}:</div>
                            <div class="dx-field-value">
                                <DxSelectBox :data-source="listList"
                                             :show-clear-button="true"
                                             display-expr="LisName"
                                             value-expr="LisId"
                                             v-model:value='mta.MatListFilterid'
                                             @value-changed="onMatListFilteridChanged">
                                </DxSelectBox>
                            </div>
                        </div>


                        <div class="dx-field" v-if="mta.AtyId == 6 || mta.AtyId == 19">
                            <div class="dx-field-label">{{ tx.RtmId }}:</div>
                            <div class="dx-field-value">
                                <DxSelectBox :data-source="resourceTypeMediaList"
                                             :show-clear-button="true"
                                             display-expr="RtmName"
                                             value-expr="RtmId"
                                             v-model:value='mta.RtmId'>
                                </DxSelectBox>
                            </div>
                        </div>

                        <div class="dx-field" v-if="mta.AtyId == 21">
                            <div class="dx-field-label">{{ tx.AttributeTypeModus }}:</div>
                            <div class="dx-field-value">
                                <DxSelectBox :data-source="attributeTypeModusList"
                                             :show-clear-button="true"
                                             display-expr="AtmName"
                                             value-expr="AtmId"
                                             v-model:value='mta.AtmId'>
                                </DxSelectBox>
                            </div>
                        </div>

                        <div class="dx-field" v-if="mta.AtyId == 1 || mta.AtyId == 2">
                            <div class="dx-field-label">{{ tx.MatDisplayAsFormattedText }}:</div>
                            <div class="dx-field-value">
                                <DxCheckBox v-model:value='mta.MatDisplayAsFormattedText'>
                                </DxCheckBox>
                            </div>
                        </div>
                        <div class="dx-field" v-if="mta.AtyId == 11">
                            <div class="dx-field-label">{{ tx.MatFormat }}:</div>
                            <div class="dx-field-value">
                                <DxTextArea v-model:value='mta.MatFormat' :autoResizeEnabled="true">
                                </DxTextArea>
                            </div>
                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">{{ tx.MatOptions }}:</div>
                            <div class="dx-field-value">
                                <DxTextArea v-model:value='mta.MatOptions' :autoResizeEnabled="true">
                                </DxTextArea>
                            </div>
                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">{{ tx.MatVisibleCondition }}:</div>
                            <div class="dx-field-value">
                                <DxTextArea v-model:value='mta.MatVisibleCondition' :autoResizeEnabled="true">
                                </DxTextArea>{{mta.MatVisibleCondition}}
                            </div>
                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">{{ tx.MatControlClass }}:</div>
                            <div class="dx-field-value">
                                <DxTextArea v-model:value='mta.MatControlClass' :autoResizeEnabled="true">
                                </DxTextArea>{{mta.MatControlClass}}
                            </div>
                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">{{ tx.MatChangedOn }}:</div>
                            <div class="dx-field-value">
                                <DxDateBox :value='mta.MatChangedOn' :readOnly="true" />
                            </div>
                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">{{ tx.MatChangedBy }}:</div>
                            <div class="dx-field-value">
                                <DxTextBox :value='mta.MatChangedBy' :readOnly="true" />
                            </div>
                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">{{ tx.MatCreatedOn }}:</div>
                            <div class="dx-field-value">
                                <DxDateBox :value='mta.MatCreatedOn' :readOnly="true" />
                            </div>
                        </div>
                        <div class="dx-field">
                            <div class="dx-field-label">{{ tx.MatCreatedBy }}:</div>
                            <div class="dx-field-value">
                                <DxTextBox :value='mta.MatCreatedBy' :readOnly="true" />
                            </div>
                        </div>
                    </div>
                </DxItem>
            </DxTabPanel>

            <div class="na-validation-summary">
                <DxValidationSummary id="naValidationSummary" />
            </div>
            <div class="na-buttons-row">
                <div>
                    <DxButton :width="120"
                              :text="btn.Save"
                              :type="saveButtonType"
                              :disabled="saveButtonDisabled"
                              :use-submit-behavior="true" />
                </div>
                <div>
                    <DxButton :width="120"
                              :text="btn.Delete"
                              type="danger"
                              @click="onDeleteClick($event)" />
                </div>

                <div>
                    <DxButton :width="120"
                              :text="btn.Back"
                              type="normal"
                              @click="onCancelClick($event)" />
                </div>
            </div>
        </div>
    </form>
</template>

<script>
    import axios from 'axios'
    import { DxTextBox, DxTextArea } from 'devextreme-vue'
    import { DxButton } from 'devextreme-vue/button'
    import { DxSelectBox } from 'devextreme-vue/select-box'
    import { DxCheckBox } from 'devextreme-vue/check-box'
    import { DxNumberBox } from 'devextreme-vue/number-box'
    import { DxTabPanel } from 'devextreme-vue/tab-panel'
    import DxValidationSummary from 'devextreme-vue/validation-summary';
    //import {
    //        DxDataGrid, DxEditing, DxLoadPanel, DxScrolling, DxColumnChooser, DxColumnFixing,
    //        DxHeaderFilter, DxSearchPanel, DxExport
    //} from 'devextreme-vue/data-grid'
    import { DxItem } from 'devextreme-vue/html-editor'
    //import { DxDateBox } from 'devextreme-vue/date-box'
    import { confirm } from "devextreme/ui/dialog"
    import {
        DxHtmlEditor,
        DxToolbar
    } from 'devextreme-vue/html-editor';
    import {
        DxValidator,
        DxRequiredRule,
        DxCompareRule,
        //DxEmailRule,
        //DxPatternRule,
        //DxStringLengthRule,
        //DxRangeRule,
        //DxAsyncRule,
    } from 'devextreme-vue/validator';
    import notify from 'devextreme/ui/notify';
    import $ from 'jquery';
    import editorConfig from '@/config/editorConfig'

    const baseUri = "WebApi.asmx/api/topicLinkTypeService";

    export default {
        name: 'ModulTypeDetail',
        components: {

            DxButton, DxTabPanel, DxItem, DxTextArea,
            DxTextBox, DxCompareRule, DxRequiredRule, DxValidator,
            //DxDataGrid, DxEditing, DxLoadPanel, DxScrolling,
            //DxDateBox, DxColumnChooser, DxColumnFixing,
            //DxHeaderFilter, DxSearchPanel, DxExport,
            DxSelectBox, DxValidationSummary,
            DxCheckBox, DxNumberBox,
            DxHtmlEditor,
            DxToolbar

        },
        data() {
            return {
                sizeValues: editorConfig.fontSizes.mixed,
                topicLinkTypeList: [],
                tx: {
                    TabBaseData: this.$LanguageProvider.GetResource("TabBaseData", "Caption", "Base Data"),
                    TabSearchPlaceholder: this.$LanguageProvider.GetResource("TabSearchPlaceholder", "Caption", "Search ..."),
                    MtyId: this.$LanguageProvider.GetResource("MtyId", "Caption", "ID"),
                    MatCaption: this.$LanguageProvider.GetResource("MatCaption", "Caption", "Caption"),
                    MatHideCaptionInReadonly: this.$LanguageProvider.GetResource("MatCaption", "Caption", "Hide Caption in Readonly View"),
                    MatIsHyperLink: this.$LanguageProvider.GetResource("MatIsHyperLink", "Caption", "Contains Hyperlink"),
                    MatDescriptionInt: this.$LanguageProvider.GetResource("MatDescriptionInt", "Caption", "Description Internal"),
                    MatDescriptionExt: this.$LanguageProvider.GetResource("MatDescriptionExt", "Caption", "Description External"),
                    MatTemplate: this.$LanguageProvider.GetResource("MatTemplate", "Caption", "Template"),
                    MatDisplayAsFormattedText: this.$LanguageProvider.GetResource("MatDisplayAsFormattedText", "Caption", "Display as Formatted Text"),
                    MatMand: this.$LanguageProvider.GetResource("MatMand", "Caption", "Mandatory"),
                    MatIsReadonly: this.$LanguageProvider.GetResource("MatIsReadonly", "Caption", "Readonly"),
                    MatPosition: this.$LanguageProvider.GetResource("MatPosition", "Caption", "Position"),
                    MatRequired: this.$LanguageProvider.GetResource("MatRequired", "Caption", "Required"),
                    MatValidationRegEx: this.$LanguageProvider.GetResource("MatValidationRegEx", "Caption", "Validation RegEx"),
                    MatValidationRegExErrorMessage: this.$LanguageProvider.GetResource("MatValidationRegExErrorMessage", "Caption", "Validation RegEx Message"),
                    MatToolTip: this.$LanguageProvider.GetResource("MatToolTip", "Caption", "Tooltip"),
                    MatListCaption: this.$LanguageProvider.GetResource("MatListCaption", "Caption", "List Caption"),
                    MatListVisible: this.$LanguageProvider.GetResource("MatListVisible", "Caption", "Visible Column"),
                    MatListPosition: this.$LanguageProvider.GetResource("MatListPosition", "Caption", "Column Position"),
                    MatOptions: this.$LanguageProvider.GetResource("MatOptions", "Caption", "Options"),
                    MatFormat: this.$LanguageProvider.GetResource("MatFormat", "Caption", "Data Format"),
                    MatListFilterid: this.$LanguageProvider.GetResource("MatListFilterid", "Caption", "List"),
                    RtmId: this.$LanguageProvider.GetResource("RtmId", "Caption", "File Type"),
                    AttributeTypeModus: this.$LanguageProvider.GetResource("AttributeTypeModus", "Caption", "Modus"),
                    MatVisibleCondition: this.$LanguageProvider.GetResource("MatVisibleCondition", "Caption", "Visible Condition"),
                    MatControlClass: this.$LanguageProvider.GetResource("MatControlClass", "Caption", "Control class"),
                    MatShowInForm: this.$LanguageProvider.GetResource("MatShowInForm", "Caption", "Show in Entry Form"),
                    MatShowInOverview: this.$LanguageProvider.GetResource("MatShowInForm", "Caption", "Show in Overview"),
                    MatShowInProfile: this.$LanguageProvider.GetResource("MatShowInProfile", "Caption", "Show in Profile"),
                    MatShowInReport: this.$LanguageProvider.GetResource("MatShowInReport", "Caption", "Show in Report"),
                    MatShowInPresentationArea: this.$LanguageProvider.GetResource("MatShowInPresentationArea", "Caption", "Show in Public View"),
                    TopicLinkType: this.$LanguageProvider.GetResource("TopicLinkType", "Caption", "Topic Link List"),
                    MatPageNr: this.$LanguageProvider.GetResource("MatPageNr", "Caption", "Page No"),
                    AttributeName: this.$LanguageProvider.GetResource("AttributeName", "Caption", "Attribute Name"),
                    AtyName: this.$LanguageProvider.GetResource("AtyName", "Caption", "Attribute Type"),
                    MatMaxLength: this.$LanguageProvider.GetResource("MatMaxLength", "Caption", "Max Length"),
                    MatMinLength: this.$LanguageProvider.GetResource("MatMinLength", "Caption", "Min Length"),
                    MatMaxFiles: this.$LanguageProvider.GetResource("MatMaxFiles", "Caption", "Max Files Count"),
                    MatShortName: this.$LanguageProvider.GetResource("MatShortName", "Caption", "Short Name"),
                    MatUniqueNumber: this.$LanguageProvider.GetResource("MatUniqueNumber", "Caption", "Unique ID"),
                    MatChangedOn: this.$LanguageProvider.GetResource("MatChangedOn", "Caption", "Changed On"),
                    MatChangedBy: this.$LanguageProvider.GetResource("MatChangedBy", "Caption", "Changed By"),
                    MatCreatedOn: this.$LanguageProvider.GetResource("MatCreatedOn", "Caption", "Created On"),
                    MatCreatedBy: this.$LanguageProvider.GetResource("MatCreatedBy", "Caption", "Created By")
                },
                btn: {
                    Save: this.$LanguageProvider.GetResource("Save", "Button", "Save"),
                    Delete: this.$LanguageProvider.GetResource("Delete", "Button", "Delete"),
                    Back: this.$LanguageProvider.GetResource("Back", "Button", "Back"),
                }
            };
        },
        computed: {
            lang() {
                return this.$LanguageProvider
            },
            mta() {
                return this.$store.state.modulTypeAttributeStore.modulTypeAttributeDetail
            },
            mtaText() {
                return JSON.stringify(this.$store.state.modulTypeAttributeStore.modulTypeAttributeDetail)
            },
            saveButtonType() {
                return this.$store.state.modulTypeAttributeStore.modulTypeAttributeDetailChanged
                    ? "success" : "normal"
            },
            saveButtonDisabled() {
                return this.$store.state.modulTypeAttributeStore.modulTypeAttributeDetailChanged
                    ? false : true
            },
            listList() {
                return this.$store.state.listStore.listList
            },
            attributeTypeModusList() {
                var result = this.$store.state.attributeTypeModusStore.attributeTypeModusList
                return result
            },
            resourceTypeMediaList() {
                return this.$store.state.resourceTypeMediaStore.resourceTypeMediaList
            }

        },
        props: {
            matId: {
                type: [Number],
                required: true,
                default: 0
            },
            atrId: {
                type: [Number],
                required: true,
                default: 0
            },
            regId: {
                type: [Number],
                required: true,
                default: 0
            },
        },
        watch: {
            mtaText: function (newVal, oldVal) {
                if (oldVal != "{}") {
                    this.$store.state.modulTypeAttributeStore.modulTypeAttributeDetailChanged = true;
                }
            },

            'mta.MatFilterTltId': function (newVal) {
                if (newVal && this.mta.MatListFilterid !== null) {
                    this.mta.MatListFilterid = null;
                    notify("Using normal lists is not possible simultaneously with using topic link lists.", "warning", 3000);
                }
            },
            'mta.MatListFilterid': function (newVal) {
                if (newVal && this.mta.MatFilterTltId !== null) {
                    this.mta.MatFilterTltId = null;
                    notify("Using normal lists is not possible simultaneously with using topic link lists.", "warning", 3000);
                }
            }
        },
        mounted: function () {
            this.$store.dispatch("getModulTypeAttributeDetail", { matId: this.matId })
                .then((res) => {
                    if (res.success) {
                        this.$store.dispatch("getAttributeTypeModusList", { atyId: res.data.AtyId });
                        this.getTopicLinkTypeListByMtyId(res.data.MtyId);
                    }
                });
            this.$store.dispatch("getListList");
            this.$store.dispatch("getResourceTypeMediaList");
        },
        methods: {
            getFieldLength() {
                return this.mta.fieldLength;
            },
            onCancelClick() {
                $("form#aspnetForm").attr("action", window.location.pathname + "?action=cancel").submit();
            },
            onSaveClick(e) {
                this.$store.dispatch("saveModulTypeAttributeDetail");
                e.preventDefault();
            },
            onDeleteClick() {
                let result = confirm("Are you sure you want to delete the module type? Deletion is not possible if linked records exist", "Confirm deletion");
                result.then((dialogResult) => {
                    if (dialogResult) {
                        this.$store.dispatch("deleteModulTypeAttributeDetail", { matId: this.matId })
                            .then(res => {
                                if (res.data.success) {
                                    $("form#aspnetForm").attr("action", window.location.pathname + "?action=cancel").submit();
                                } else {
                                    alert("On error occured", "Deleting Record");
                                }
                            });
                    }
                });
            },
            getTopicLinkTypeListByMtyId(mtyId) {
                axios.get(baseUri + '/GetTopicLinkTypeListByMtyId', { params: { mtyId } })
                    .then(response => {
                        if (response.data.success) {
                            this.topicLinkTypeList = response.data.list;
                        } else {
                            console.error("Error: " + response.data.message);
                        }
                    })
                    .catch(error => {
                        console.error("Error fetching TopicLinkTypeList:", error);
                    });
            },
        }
    }


</script>
<style>
    div#tsGridFields {
        max-height: 620px;
    }


    .tsHeaderCell.dx-template-wrapper {
        writing-mode: vertical-rl;
    }

    .dx-datagrid-nowrap .dx-header-row > td.tsDynHeader > .dx-datagrid-text-content {
        display: inline;
    }
</style>
